import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Spin, Form, message, Button } from 'antd';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import moment from 'moment';//日期格式化导包

import './completeWPAFormThanks.css';
import '../newMain/newMain.css';


const CompleteWPAFormThanks = (props) => {
    const { authorizationCode } = useParams();
    const [isLoad, setIsLoad] = useState(false);
    const [isShow, setIsShow] = useState(true);
    const [form] = Form.useForm();
    useEffect(() => {
        if (authorizationCode) {
            checkCode()
        } else {
            message.error("Link has failed.");
            setIsShow(false);
        }
    }, []);
    
    const checkCode = () => {
        if(isLoad) {
            return;
        }
        let model = {authorizationCode: authorizationCode};
        setIsLoad(true);
        fetch(Config.apiServer + "partner/wpaAppl/checkExport", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsShow(true)
            } else {
                message.error(data.msg);
                setIsShow(false);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }
    
    const generatePdf = (lang) => {
        if (isLoad) {
            return;
        }
        setIsLoad(true);
        let model = {authorizationCode: authorizationCode, lang};
        fetch(Config.apiServer + "partner/partnerWPAFormPdf/generatePdf", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    console.log(data);
                    // errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                var filename = "WPAForm" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".pdf";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename;
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    return (
        <div id="container" className='websiteTemplate completeWPAFormThanks'>
            {isShow ? <Spin size="large" spinning={isLoad} >
                <div className='websiteSysContentBox'>
                    <Form form={form}>
                        <div className='marginBotAndtop'>
                            <div className='contentTitle'>
                                谢谢完成本工作综合学习- 学生工作表现评估。
                            </div>
                            <div className='contentTitle'>
                                謝謝完成本工作綜合學習- 學生工作表現評估。
                            </div>
                            <div className='contentTitle'>
                                Thank you for completing this WIL - Student Work Performance Appraisal.
                            </div>
                        </div>
                        
                        <div className='marginBotAndtop2'>
                        <div className='contentTitle'>
                            <Button className='websiteSysButton signatureButton' onClick={() => generatePdf("SC")}>下载本工作综合学习- 学生工作表现评估</Button>
                        </div>
                        <div className='contentTitle'>
                            <Button  className='websiteSysButton signatureButton' onClick={() => generatePdf("TC")}>下載本工作綜合學習- 學生工作表現評估</Button>
                        </div>
                        <div className='contentTitle'>
                            <Button className='websiteSysButton signatureButton' onClick={() => generatePdf("EN")}>To download the WIL - Student Work Performance Appraisal</Button>
                        </div>
                        </div>
                    </Form>
                </div>
            </Spin>
                : <div className='contentTitle'>Link has failed.</div>
            }
        </div>
    )

}

export default CompleteWPAFormThanks;